import { render, staticRenderFns } from "./ProfileWrapper.vue?vue&type=template&id=93d76b94&scoped=true"
import script from "./ProfileWrapper.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProfileWrapper.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ProfileWrapper.vue?vue&type=style&index=0&id=93d76b94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93d76b94",
  null
  
)

export default component.exports